import "./../css/Footer.css";

export default function Footer() {
  return (
    <>
      <footer className="footer">
        {/* Powered By Ecocash &amp; Core Create &copy; {year} */}
        Powered By Ecocash &amp; Core Create
      </footer>
    </>
  );
}
